import {
  DistanceUnit,
  WeightUnit,
} from "@api/graphql/generated/generated-types";

export const weightUnitLabel = (weightUnit: WeightUnit): string => {
  return weightUnit === WeightUnit.Kg ? "kg" : "lbs";
};

export const distanceUnitLabel = (distanceUnit: DistanceUnit): string => {
  return distanceUnit === DistanceUnit.Kilometer ? "km" : "mi";
};

export const distanceUnitLabelFull = (distanceUnit: DistanceUnit): string => {
  return distanceUnit === DistanceUnit.Kilometer ? "km" : "miles";
};

export const perDistanceUnitLabel = (distanceUnit: DistanceUnit): string => {
  return distanceUnit === DistanceUnit.Kilometer ? "Per km" : "Per Mile";
};

export const formatSpeed = (
  secondsPerMile: number,
  distanceUnit: DistanceUnit
): string => {
  if (!Number.isFinite(secondsPerMile)) return "";

  if (distanceUnit === DistanceUnit.Kilometer) {
    const secondsPerKm = secondsPerMile / 1.609344;
    return `${(secondsPerKm / 60).toFixed(2)} min/km`;
  }

  return `${(secondsPerMile / 60).toFixed(2)} min/mile`;
};
